// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBQm2tjQuNz6QTfjWCkI1FnFlZigpjwP_w",
  authDomain: "part-it-out.firebaseapp.com",
  projectId: "part-it-out",
  storageBucket: "part-it-out.appspot.com",
  messagingSenderId: "388500002188",
  appId: "1:388500002188:web:2d0cd5f8ae2a6c1d6e72a9",
  measurementId: "G-NKMKCW37S2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const storage = getStorage(app)
